import { useEffect } from 'react';

export default function useNavigationPrompt(
    when: boolean,
    message = 'You have unsaved changes. Do you want to leave this page?'
) {
    useEffect(() => {
        if (!when) return;

        const onClick = (e: MouseEvent) => {
            try {
                const target = e.target as HTMLElement | null;
                if (!target) return;
                const anchor = target.closest?.('a') as HTMLAnchorElement | null;
                if (!anchor) return;

                const href = anchor.getAttribute('href');
                if (!href) return;

                if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
                const isExternal = href.startsWith('http') && !href.startsWith(window.location.origin);
                if (isExternal) return;

                const allow = window.confirm(message);
                if (!allow) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            } catch {
                // swallow
            }
        };

        const onPopstate = () => {
            try {
                const allow = window.confirm(message);
                if (!allow) {
                    window.history.pushState(null, '', window.location.href);
                }
            } catch {
                // ignore
            }
        };

        document.addEventListener('click', onClick, true);
        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', onPopstate);

        return () => {
            document.removeEventListener('click', onClick, true);
            window.removeEventListener('popstate', onPopstate);
        };
    }, [when, message]);
}
